import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/auth-context';
import { hasAccess, ROUTE_TIERS } from '../config/tier-config';
import './sidebar-nav.css';

// Order matters — rendered in this sequence, filtered down to what the
// signed-in user's tier unlocks (see NAV_ITEMS.filter below).
const NAV_ITEMS = [
  { to: '/dashboard',            icon: '\u{1F4CA}', label: 'Dashboard' },
  { to: '/watchlist',            icon: '⭐',     label: 'Watchlist', dataTour: 'nav-watchlist' },
  { to: '/rubberband',           icon: '\u{1F3F9}',  label: 'RBPullback' },
  { to: '/20-50-pullback',       icon: '〽️', label: '20-50 Pullback' },
  { to: '/rsi-mtf',              icon: '\u{1F4E1}',  label: 'RSI-MTF' },
  { to: '/volume-spike',         icon: '⚡',     label: 'Volume Spike' },
  { to: '/cci-pullback',         icon: '\u{1F4CA}',  label: 'CCI Pullback' },
  { to: '/mtf-50sma',            icon: '\u{1F4C8}',  label: 'MTF 50 SMA' },
  { to: '/topdog',               icon: '\u{1F415}',  label: 'ProjectTD' },
  { to: '/topdog-cci-combined',  icon: '\u{1F517}',  label: 'ProjectTD + CCI' },
  { to: '/trend-pullback',       icon: '\u{1F3AF}',  label: 'Trend Pullback' },
  { to: '/20ema-sr',             icon: '\u{1F9F1}',  label: '20 EMA S/R' },
  { to: '/20-8ema-parabolic',    icon: '\u{1F680}',  label: '20/8 EMA Parabolic' },
  { to: '/trend-breakout',       icon: '🧭',     label: 'Trend Breakout' },
  { to: '/ttm-squeeze',          icon: '🧨',     label: 'TTM Squeeze' },
  { to: '/ttm-triple-squeeze',   icon: '🧨',     label: 'TTM Triple Squeeze' },
  { to: '/ma-crossover',         icon: '🔀',     label: 'MA Crossover' },
  { to: '/kc-extreme',           icon: '📏',     label: 'KC Extreme' },
  { to: '/combined',           icon: '\u{1F9E9}',  label: 'Combined' },
  { to: '/alerts-log',           icon: '\u{1F4CB}',  label: 'Alerts Log', dataTour: 'nav-alerts-log' },
  { to: '/support',              icon: '❓',     label: 'Support', dataTour: 'nav-support' },
  { to: '/settings',             icon: '⚙️', label: 'Settings', dataTour: 'nav-settings' },
];

function NavItem({ to, icon, label, dataTour }) {
  return (
    <NavLink
      to={to}
      data-tour={dataTour}
      className={function(ref) { return 'nav-item' + (ref.isActive ? ' active' : ''); }}
    >
      <span className="nav-icon">{icon}</span>
      <span className="nav-text">{label}</span>
    </NavLink>
  );
}

function SidebarNav() {
  const { user, tier, signOut } = useAuth();

  const initials = user
    ? (user.displayName
        ? user.displayName.split(' ').map(function(n) { return n[0]; }).join('').toUpperCase().slice(0, 2)
        : (user.email ? user.email[0].toUpperCase() : '?'))
    : null;

  const tierBadgeClass = 'tier-badge tier-' + tier;

  return (
    <div className="sidebar-nav">
      <div className="logo">
        <img src="/logo.svg" alt="CryptoProScanner" className="logo-full" />
        <img src="/icon.svg" alt="CryptoProScanner" className="logo-collapsed" />
      </div>

      <nav className="nav-menu">
        {NAV_ITEMS
          .filter(item => hasAccess(tier, ROUTE_TIERS[item.to]))
          .map(item => (
            <NavItem key={item.to} to={item.to} icon={item.icon} label={item.label} dataTour={item.dataTour} />
          ))}
      </nav>

      <div className="sidebar-footer">
        {user ? (
          <div className="sidebar-user">
            <div className="user-avatar">{initials}</div>
            <div className="user-info">
              <div className="user-email">{user.email || user.displayName || 'User'}</div>
              <span className={tierBadgeClass}>{tier}</span>
            </div>
            <button className="signout-btn" onClick={signOut} title="Sign out">&#8594;</button>
          </div>
        ) : (
          <div className="status-indicator">
            <div className="status-dot"></div>
            <span>Live Data</span>
          </div>
        )}
      </div>
    </div>
  );
}

export default SidebarNav;
